(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/collections/members.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/collections/members.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.syndicate.core.collections.Members = Backbone.Collection.extend({
    model: svs.syndicate.core.models.Member,

    orderBy: 'firstName',

    getCurrentUser: function() {
      return this.findWhere({ isCurrentMember: true });
    },

    comparator: function(model) {
      var orderBy = this.orderBy;
      return [model.get(orderBy)];
    }
  });
})(Backbone, _, svs);


 })(window);